import { type Session, TWO_FA_STATUS } from '@/entities/session';
import {
  useAppSettingsStore,
  useExecuteOnce,
  useModalStore,
} from '@/shared/lib';
import { useTwoFactorSettingsModals } from './useTwoFactorSettingsModals';

const useTwoFactorModalAfterLogin = (
  session: Session | null,
  isDisabled?: boolean
) => {
  const { closeDialog } = useModalStore();
  const { openTwoFactorAppEnableModal } = useTwoFactorSettingsModals();
  const { isTwoFAShown, setTwoFAShown } = useAppSettingsStore();

  const isTwoFactorOptional =
    session?.additional?.twoFAStatus === TWO_FA_STATUS.OPTIONAL;

  const isTwoFactorRequired =
    session?.additional?.twoFAStatus === TWO_FA_STATUS.REQUIRED;

  const userId = session?.userId;

  const shouldShowModal = Boolean(
    userId &&
      (isTwoFactorRequired || (isTwoFactorOptional && !isTwoFAShown(userId)))
  );

  useExecuteOnce(() => {
    if (!userId || isDisabled) return;

    if (isTwoFactorOptional) {
      setTwoFAShown(userId, true);
    }

    openTwoFactorAppEnableModal({
      showCloseButton: isTwoFactorOptional,
      preventOverlayClose: isTwoFactorRequired,
      onSuccess: closeDialog,
      ...(isTwoFactorOptional ? { onSkip: closeDialog } : {}),
    });
  }, shouldShowModal);

  return {
    shouldShowModal,
    openTwoFactorAppEnableModal,
    isTwoFactorOptional,
    isTwoFactorRequired,
  };
};

export { useTwoFactorModalAfterLogin };
